import React from 'react'

import LabelDetail from '../../UI/Label/LabelDetail'


const Headline = props => {
    const { name, last_name, second_surname, rfc, curp, email, email_2, phone, phone_2 } = props.headline

    return (
        <div className="columns">
            <div className="column">
                <table className='table is-bordered is-fullwidth table-info'>
                    <tbody>
                        <tr>
                            <td>
                                <LabelDetail
                                    title='nombre'
                                    description={name}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='apellido paterno'
                                    description={last_name}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='apellido materno'
                                    description={second_surname}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='rfc'
                                    description={rfc}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <LabelDetail
                                    title='curp'
                                    description={curp}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='correo electrónico'
                                    description={email}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='correo electrónico 2'
                                    description={email_2}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <LabelDetail
                                    title='teléfono'
                                    description={phone}
                                />
                            </td>
                            <td colSpan="2">
                                <LabelDetail
                                    title='teléfono 2'
                                    description={phone_2}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Headline


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Detail/Headline.js